import React from 'react'

import LoginActivation from '../../components/Demo/LoginActivation'

export default function LoginActivationPage() {
  return <LoginActivation />
}
